import { cacheDom } from "../utils/QuerySelectors.js"
import { validateEmail } from "../utils/helpers.js"
const dom = {};
const qs = {
  input: 'data-newsletter-input',
  submit: 'data-newsletter-submit',
}
const qsAll = {
  newsletters: 'data-newsletter',
}

const formSubmit = (newsletter) => {
  const input = newsletter.querySelector(`[${qs.input}]`)

}

const submitHandler = (newsletter) => {
  const input = newsletter.querySelector(`[${qs.input}]`)
  if(newsletter.querySelector('.input-error')) newsletter.querySelector('.input-error').remove()
  if(validateEmail(input.value))
    formSubmit(newsletter)
  else {
    const node = document.createElement("p")
    const textnode = document.createTextNode("Please enter a valid email.")
    node.appendChild(textnode)
    node.className = 'input-error'
    newsletter.querySelector('.input-wrap').appendChild(node)
  }
}

const initEmbedForm = (newsletter) => {
  const input = newsletter.querySelector(`[${qs.input}]`)
  const submit = newsletter.querySelector(`[${qs.submit}]`)
  input.addEventListener('keypress', (e) => {
    if(e.keyCode === 13) submitHandler(newsletter)
  })
  submit.addEventListener('click', () => {
    submitHandler(newsletter)
  })
}

export const setupNewsletters = () => {
  cacheDom(dom, qs, qsAll)
  dom.newsletters.forEach((newsletter) => {
    initEmbedForm(newsletter)
  })
}